import React from 'react';
import Spin from 'antd/es/spin';

const Loading = () => {
  return (
    <>
      <div className="fixed w-full h-full z-[2000] top-0 left-0 flex justify-center items-center">
        <div className="w-full h-full absolute bg-black opacity-20" />
        <Spin size="large" className="" />
      </div>
    </>
  );
};

export { Loading };
export default Loading;
